import { useState } from "react";
import axios from "axios";
import { WifiMark } from "@/components/WifiMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LoginForm = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await axios.post(`${API}/auth/login`, { email, password });
            onLogin(data.token);
        } catch (err) {
            const d = err.response?.data?.detail;
            setError(typeof d === "string" ? d : "Login failed — check your credentials");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex items-center justify-center px-6 py-24">
            <form onSubmit={submit} className="w-full max-w-sm border border-zinc-800 p-8 sm:p-10" data-testid="admin-login-form">
                <WifiMark className="h-8 w-auto mb-6" />
                <h1 className="font-display font-semibold uppercase tracking-tight text-2xl mb-1">Studio Login</h1>
                <p className="text-xs text-zinc-500 mb-8">Staff only. Signal required, ironically.</p>

                <label className="block mb-5">
                    <span className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">Email</span>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="admin-email-input"
                        className="mt-1 w-full bg-transparent border border-zinc-800 px-3 py-3 text-sm focus:outline-none focus:border-signal transition-colors duration-300"
                    />
                </label>
                <label className="block mb-6">
                    <span className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">Password</span>
                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        data-testid="admin-password-input"
                        className="mt-1 w-full bg-transparent border border-zinc-800 px-3 py-3 text-sm focus:outline-none focus:border-signal transition-colors duration-300"
                    />
                </label>

                {error && (
                    <p className="text-signal text-xs tracking-[0.15em] uppercase mb-4" data-testid="admin-login-error">
                        {error}
                    </p>
                )}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-submit"
                    className="w-full bg-white text-void py-3 text-[11px] tracking-[0.3em] uppercase font-medium hover:bg-signal hover:text-white transition-colors duration-300 disabled:opacity-50"
                >
                    {loading ? "Connecting…" : "Enter studio"}
                </button>
            </form>
        </div>
    );
};
